import React from 'react';
import {CSVLink, CSVDownload} from 'react-csv';
import csv_headers, {get_csv_data} from '../data/csv';
import { Button, Tooltip } from 'antd';

const CsvDownload = ({data, tableName}) => (
  <CSVLink headers={csv_headers} data={get_csv_data(data)} filename={`${tableName}.csv`} >
    <Tooltip title="Download all data as csv file">
      <Button type="primary" icon="download" size="large">Excel</Button>
    </Tooltip>
  </CSVLink>
)

export default CsvDownload;




// WEBPACK FOOTER //
// ./src/components/CsvDownload.js